module.exports = __webpack_public_path__ + "gt.e2a8f7ec.svg";